/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterPSmall = createReactComponent("letter-p-small", "IconLetterPSmall", [
  ["path", { d: "M10 12h2a2 2 0 1 0 0 -4h-2v8", key: "svg-0" }]
]);

export { IconLetterPSmall as default };
//# sourceMappingURL=IconLetterPSmall.js.map
